import { atom, useRecoilValue } from 'recoil';
import { v1 } from "uuid";
export const searchModalState = atom({
    key: `searchModalState/${v1()}`,
    default: { modalOpen: false, search: '' },
});

export const useSearchModal = () => {
    const searchModal = useRecoilValue(searchModalState);
    return searchModal;
};